<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">

    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">VALET SERVIZIO</a>
      </label>
    </div>
    
    <div class="button-wrapper">
      <button class="btn btn-white vertical align-items-center" routerLink="/valet/servizi/nuovo">
        Aggiungi Valet Servizio<i class="ml-30 fas fa-plus"></i>
      </button>
    </div>

    <section class="main-content wrapper content-padding">

      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>

      <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form  class="table-row-container row first-row filter" [formGroup]="expertServiceFilterForm" (ngSubmit)="filter()" *ngIf="expertServiceFilterForm">
          <div class="item data-col-10">
            <h4 class="title" (click)="navigateOrder('ExpertService.id')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Service.id')"></i>
              ID
            </h4>
            <span class="data">
              <input type="number" formControlName="ExpertService.id" min="1000" max="10000" >
            </span>
          </div>

          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('ExpertService.serviceName')">
              <i class="sort-icon fas" [ngClass]="orderIcon('ExpertService.serviceName')"></i>
              Nome Servizio
            </h4>
            <span class="data">
              <input type="text" formControlName="ExpertService.serviceName" >  
            </span>
          </div>

          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('ExpertService.serviceType')">
              <i class="sort-icon fas" [ngClass]="orderIcon('ExpertService.serviceType')"></i>
              Tipo Servizio
            </h4>
            <span class="data">
              <select formControlName="ExpertService.serviceType">
                <option value="">Tutti</option>
                  <option value="fixedpricesalary">Servizi a Prezzo Fisso</option>
                  <option value="hourlyratesalary">Servizi in Ora</option>
                  <option value="warehousesalary">Servizi Magazzino</option>
              </select>
            </span>
          </div>

          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('ExpertService.notes')">
              <i class="sort-icon fas" [ngClass]="orderIcon('ExpertService.notes')"></i>
              Note
            </h4>
            <span class="data">
              <input type="text" formControlName="ExpertService.notes" > 
            </span>
          </div>

          <div class="item nowrap">
            <h4 class="title hide-on-mobile">AZIONI</h4>
            <span class="data-row-left btn-container">
              <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                RICERCA <i class="fas fa-search"></i></button>
                <br/>
              <button class="btn vertical align-items-center" (click)="fnReset();">
                RESET <i class="fas fa-times-circle"></i></button>
            </span>
          </div>
        </form>

        <div class="table-row-container row" *ngFor="let expertService of expertServices">
          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              ID
            </h4>
            <div class="data data-id">
              <div>{{ expertService?.id || "N/A" }}</div>
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Nome Servizio
            </h4>
            <div class="data">
              <div>{{ expertService?.serviceName || "N/A" }}</div>
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Tipo Servizio
            </h4>
            <div class="data">
              {{ expertService?.serviceType | serviceName }} 
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Notes
            </h4>
            <div class="data">
              <div>{{ expertService?.notes || "N/A" }}</div>
            </div>
          </div>

          <div class="item nowrap">
            <span class="data-row-left btn-container">
              <button class="btn hvr-grow has-margin-right has-margin-bottom has-margin-right has-margin-top" [routerLink]="['/valet/servizi', expertService?.id, 'edit']">
                MODIFICA
              </button>
              <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); deleteExpertService(expertService?.id)">
                Elimina<i class="ml-10 far fa-trash-alt"></i>
              </button>
            </span>
          </div>

        </div>
      </div>
    </section>
  </div>
</section>

<!--
<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading">Valet Servizio</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
        <button class="btn btn-white vertical align-items-center" routerLink="/valet/servizi/nuovo">
          Aggiungi Valet Servizio<i class="ml-30 fas fa-plus"></i>
        </button>
      </span>
    </div>
  </div>
</section>

<section class="main-content wrapper content-padding">
  <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
  <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
    <form  class="table-row-container row first-row filter" [formGroup]="expertServiceFilterForm" (ngSubmit)="filter()" *ngIf="expertServiceFilterForm">
      <div class="item data-col-10">
        <h4 class="title" (click)="navigateOrder('ExpertService.id')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Service.id')"></i>
          ID
        </h4>
        <span class="data">
          <input type="number" formControlName="ExpertService.id" min="1000" max="10000" >
        </span>
      </div>

      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('ExpertService.serviceName')">
          <i class="sort-icon fas" [ngClass]="orderIcon('ExpertService.serviceName')"></i>
          Nome Servizio
        </h4>
        <span class="data">
          <input type="text" formControlName="ExpertService.serviceName" >  
        </span>
      </div>

      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('ExpertService.serviceType')">
          <i class="sort-icon fas" [ngClass]="orderIcon('ExpertService.serviceType')"></i>
          Tipo Servizio
        </h4>
        <span class="data">
          <input type="text" formControlName="ExpertService.serviceType" >  
        </span>
      </div>

      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('ExpertService.notes')">
          <i class="sort-icon fas" [ngClass]="orderIcon('ExpertService.notes')"></i>
          Note
        </h4>
        <span class="data">
          <input type="text" formControlName="ExpertService.notes" > 
        </span>
      </div>

      <div class="item nowrap">
        <h4 class="title hide-on-mobile">AZIONI</h4>
        <span class="data-row-left btn-container">
          <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
            RICERCA <i class="fas fa-search"></i></button>
            <br/>
          <button class="btn vertical align-items-center" (click)="fnReset();">
            RESET <i class="fas fa-times-circle"></i></button>
        </span>
      </div>
    </form>

    <div class="table-row-container row" *ngFor="let expertService of expertServices">
      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          ID
        </h4>
        <div class="data data-id">
          <div>{{ expertService?.id || "N/A" }}</div>
        </div>
      </div>

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          Nome Servizio
        </h4>
        <div class="data">
          <div>{{ expertService?.serviceName || "N/A" }}</div>
        </div>
      </div>

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          Tipo Servizio
        </h4>
        <div class="data">
          <div>{{ expertService?.serviceType?.toUpperCase() || "N/A" }}</div>
        </div>
      </div>

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          Notes
        </h4>
        <div class="data">
          <div>{{ expertService?.notes || "N/A" }}</div>
        </div>
      </div>

      <div class="item nowrap">
        <span class="data-row-left btn-container">
          <button class="btn hvr-grow has-margin-right has-margin-bottom has-margin-right has-margin-top" [routerLink]="['/valet/servizi', expertService?.id, 'edit']">
            MODIFICA
          </button>
          <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); deleteExpertService(expertService?.id)">
            Elimina<i class="ml-10 far fa-trash-alt"></i>
          </button>
        </span>
      </div>

    </div>
  </div>
</section>
-->
  